import React from 'react';
import {DateTime} from 'components/UI/DateTime';
import {UploadImage} from 'components/UI/Image';
import MyMessageHeading from './partials/MyMessageHeading.jsx';

class MessageItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      message: this.props.message
    }
  }

  render() {
    return (
      <div className={`item-comment-container ${this.props.isMe ? 'my-message' : ''} ${this.props.isUserView ? 'user-message' : ''}`}>
        {this.props.isMe &&
          <MyMessageHeading
            user={this.state.message.user}
            message={this.state.message}
          />

        }
        {
          this.props.customHeading && !this.props.isMe &&
          <this.props.customHeading/>
        }
        {
          (!this.props.customHeading && !this.props.isMe) &&
          <div className='item-comment-header'>
            <div className='content-justify'>
              <p className='item-comment-business-name'>{this.state.message.user && this.state.message.user.fullname}</p>
              <p className='item-comment-business-desc'><DateTime dateTime={this.state.message.createdAt}/></p>
            </div>
            <div className='item-comment-business-address'>
              <span className='item-comment-business-desc mr25'>Địa chỉ:&nbsp;{this.state.message.user.address}</span>
              <span className='item-comment-business-desc'>Số điện thoại:&nbsp;{this.state.message.user.phone}</span>
            </div>
          </div>
        }

        <div className='item-comment-content'>
          <p className='item-comment-business-desc'>{this.state.message.content}</p>
        </div>
        {
          this.props.extraBlocks &&
          <this.props.extraBlocks />
        }

      </div>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./components/conversations/MessageItem.jsx